<template>
	<div></div>
</template>

<script>
export default {
	name: "Logout",
	beforeMount() {
		this.$store.commit("logout")
		// reenvio por ahi para que cargue todo bien desde apollo provider
		window.location.href = "/"
	}
}
</script>
